import { AxiosResponse } from 'axios';
import { acceptHMRUpdate, defineStore } from 'pinia';
import AuthService from '@/services/auth.service';
import { IRegisterUser, IUserLogin } from '@/types/common/general';
import { ref } from 'vue';

interface IState {
  user: Record<string, unknown> | undefined;
}

const initialState: IState = { user: AuthService.getUser() };
const isAuthenticatedState = ref(false);

export const useAuthStore = defineStore('auth.store', {
  state: (): IState => ({ ...initialState }),
  getters: {
    isAuthenticated: () => isAuthenticatedState.value,
  },
  actions: {
    async checkAuthenticated(forceCheck = false) {
      isAuthenticatedState.value = await AuthService.isAuthenticated(forceCheck);
      return isAuthenticatedState.value;
    },
    login(user: IUserLogin) {
      return AuthService.login(user).then(
        async (response: AxiosResponse) => {
          this.user = response.data;
          await this.checkAuthenticated(true);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    setUser(user: Record<string, unknown> | undefined) {
      this.user = user;
    },
    logout() {
      return AuthService.logout().then(() => {
        this.user = undefined;
        isAuthenticatedState.value = false;

        setTimeout(() => {
          window.location.href = '/';
        }, 300);
      });
    },
    register(user: IRegisterUser) {
      return AuthService.register(user);
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
